export const SAVE_TASK_DETAIL = 'typeTask/SAVE_TASK_DETAIL';

export const UPDATE_TASK_VIEW = 'typeTask/UPDATE_TASK_VIEW';

export const SET_PAGE_IDS = 'typeTask/SET_PAGE_IDS';

export const APPEND_PAGE_IDS = 'typeTask/APPEND_PAGE_IDS';

export const SET_TASK_VIEW = 'typeTask/SET_TASK_VIEW';

export const SELECT_TASK = 'typeTask/SELECT_TASK';

export const CLEAR_SELECT_TASKS = 'typeTask/CLEAR_SELECT_TASKS';

export const SELECT_ALL_TASK = 'typeTask/SELECT_ALL_TASK';

export const CLEAR_ALL_SELECT = 'typeTask/CLEAR_ALL_SELECT';

export const ADD_TO_UNSELECTED_TASKS = 'typeTask/ADD_TO_UNSELECTED_TASKS';

export const CLEAR_UNSELECT_TASKS = 'typeTask/CLEAR_UNSELECT_TASKS';

export const RESET = 'typeTask/RESET';

export const SET_SORT = 'typeTask/SET_SORT';

export const SET_PERSIST_TYPE_TASKS_VISIBLE_STATE = 'typeTask/SET_PERSIST_TYPE_TASKS_VISIBLE_STATE';
